import React from 'react';

import { useTranslation } from 'react-i18next';

import { designSystemTokens } from '../../tokens';
import { Icons } from '../Icons';
import { Typography } from '../Typography';

import { Container, IconContainer, type verticalMargins } from './styles';

interface CallOutProps {
    verticalMargins?: verticalMargins;
}

export const CallOut = ({ verticalMargins }: CallOutProps) => {
    const { t } = useTranslation(['artifacts']);
    return (
        <Container verticalMargins={verticalMargins}>
            <IconContainer>
                <Icons.ETH />
            </IconContainer>
            <Typography
                type={'paragraph'}
                theme={'dark'}
                size={12}
                align={'left'}
                color={designSystemTokens.shades.primary.light[50]}
                weight={'600'}
            >
                {t('eth_warning')}
            </Typography>
        </Container>
    );
};
